export function persistToken(key: string, value: string) {
  localStorage.setItem(key, value)
}

export function deleteToken(key: string) {
  localStorage.removeItem(key)
}

export const getPersistedToken = (key: string): string | null => {
  return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null
}
